export default class LocationHash {
  constructor() {
    this.hashes = [];
    this.separator1 = '&';
    this.separator2 = '=';
  }

  /**
   * Parse the variables out of the window URL
   */
  parse() {
    var output = {};

    var pieces = String(window.location).split('#');
    if (pieces.length != 2) {
      return output;
    }
    var params = pieces[1];

    var paramPieces = params.split(this.separator1);
    for (var i = 0; i < paramPieces.length; i++) {
      var keyValue = paramPieces[i].split(this.separator2);
      if (keyValue.length == 2) {
        var key = keyValue[0];
        var value = keyValue[1];
        if (key == 'keywords') {
          value = decodeURIComponent(value);
        } else if (value == 'true') {
          value = true;
        } else if (value == 'false') {
          value = false;
        }
        output[key] = value;
      }
    }

    return output;
  }

  /**
   * Set a variable in the window URL
   */
  set(key, value) {
    key = this.slugify(key);

    // Undefined
    if (value === undefined || value === null) {
      delete this.hashes[key];
      return;

      // Array
    } else if (Array.isArray(value)) {
      var allFalse = true;
      for (var i = 0; i < value.length; i++) {
        if (value[i] !== false) {
          allFalse = false;
          break;
        }
      }
      if (allFalse) {
        delete this.hashes[key];
        return;
      }
      value = value.map(this.slugify).join(',');
      if (value.length == 0) {
        delete this.hashes[key];
        return;
      }

      // Boolean
    } else if (typeof value == 'boolean') {
      if (value === false) {
        delete this.hashes[key];
        return;
      }

      // Keywords
    } else if (key == 'keywords') {
      value = encodeURIComponent(value);
      if (value == '') {
        delete this.hashes[key];
        return;
      }

      // String
    } else {
      value = this.slugify(value);
      if (value == '') {
        delete this.hashes[key];
        return;
      }
    }

    this.hashes[key] = value;
  }

  /**
   * Get a variable in the window URL
   */
  get(key) {
    return this.hashes[this.slugify(key)];
  }

  /**
   * Reset variables in the window URL
   */
  reset() {
    this.hashes = [];
    history.replaceState(null, null, ' ');
  }

  /**
   * When the window URL has been updated
   */
  update() {
    var a = [];
    for (const [key, value] of Object.entries(this.hashes)) {
      a.push(key + this.separator2 + value);
    }
    a.sort();
    var s = String(window.location).split('#')[0];
    s = s.split('?uniqueID')[0];
    if (a.length == 0) {
      window.history.replaceState(null, null, s);
    } else {
      window.history.replaceState(null, null, s + '#' + a.join(this.separator1));
    }
  }

  /**
   * Slugify
   */
  slugify(s) {
    return String(s)
      .normalize('NFKD') // split accented characters into their base characters and diacritical marks
      .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
      .trim() // trim leading or trailing whitespace
      .toLowerCase() // convert to lowercase
      .replace(/[^a-z0-9 -_]/g, '') // remove non-alphanumeric characters
      .replace(/_+/g, '-') // replace underscores with hyphens
      .replace(/\s+/g, '-') // replace spaces with hyphens
      .replace(/-+/g, '-'); // remove consecutive hyphens
  }
}
